import React, { useState, Fragment } from 'react';
import { SearchOverlay } from './SearchOverlay';
export function Header() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <>
      <header className="w-full bg-white border-b border-light relative z-50" data-id="element-27">
        <div className="site-container py-4 lg:py-5 flex items-end justify-between" data-id="element-28">
          {/* LEFT: Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate - The Marketing and Advertising Resource" className="h-[36px] md:h-[44px] lg:h-[50px] w-auto object-contain" data-id="element-30" />
          </a>

          {/* CENTER: Nav Links + Search */}
          <div className="hidden xl:flex items-end gap-6" data-id="element-31">
            <nav className="flex items-end leading-none pb-[2px]" data-id="element-32">
              {['News', 'Brands', 'Agencies', 'Focus', 'Editions', 'Ranking'].map((item, index, array) => <Fragment key={item} data-id="element-33">
                  <a href={`#${item.toLowerCase()}`} className="text-grey text-nav text-upper hover:text-black transition-colors" style={{
                letterSpacing: '0.14em'
              }} data-id="element-34">
                    {item}
                  </a>
                  {index < array.length - 1 && <span className="text-grey text-nav mx-2 lg:mx-4" style={{
                letterSpacing: '0.14em'
              }} data-id="element-35">
                      I
                    </span>}
                </Fragment>)}
            </nav>
            <button onClick={() => setIsSearchOpen(true)} className="flex items-center justify-center hover:opacity-70 transition-opacity" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/patterns/figma-svgs/qMYA2TKA2kze7CZ7XfjFwj/1058-5.svg" alt="Search" className="w-5 h-5 lg:w-6 lg:h-6" data-id="element-37" />
            </button>
          </div>

          {/* RIGHT: Adweek + Mobile controls */}
          <div className="flex items-end gap-4 lg:gap-8" data-id="element-38">
            {/* Mobile search */}
            <button onClick={() => setIsSearchOpen(true)} className="xl:hidden flex items-center justify-center hover:opacity-70 transition-opacity" data-id="element-39">
              <img src="https://cdn.magicpatterns.com/patterns/figma-svgs/qMYA2TKA2kze7CZ7XfjFwj/1058-5.svg" alt="Search" className="w-5 h-5" data-id="element-40" />
            </button>

            <div className="hidden xl:flex items-end" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/afZs6hY7Xvo5fyLHudaDXF/adweek.svg" alt="Adweek" className="w-[160px] h-auto object-contain" data-id="element-42" />
            </div>

            {/* Mobile Menu Toggle */}
            <button className="xl:hidden hover:opacity-70 transition-opacity" onClick={() => setIsMobileMenuOpen(true)} style={{
            color: '#6B6B6B'
          }} data-id="element-43">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" data-id="element-44">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" data-id="element-45" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Full-screen Mobile Menu */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[100] flex flex-col" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-46">
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between px-4 py-4" data-id="element-47">
            <a href="#" className="flex-shrink-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-48">
              <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate" className="h-[40px] w-auto object-contain" data-id="element-49" />
            </a>
            <button onClick={() => setIsMobileMenuOpen(false)} className="hover:opacity-70 transition-opacity" style={{
          color: '#6B6B6B'
        }} data-id="element-50">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-7 h-7" data-id="element-51">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-52" />
              </svg>
            </button>
          </div>

          {/* Mobile Nav Links */}
          <nav className="flex-1 flex flex-col items-center justify-center gap-8" data-id="element-53">
            {['News', 'Brands', 'Agencies', 'Focus', 'Editions', 'Ranking'].map(item => <a key={item} href={`#${item.toLowerCase()}`} onClick={() => setIsMobileMenuOpen(false)} className="uppercase tracking-widest hover:opacity-70 transition-opacity" style={{
          color: '#6B6B6B',
          fontSize: '20px',
          fontFamily: 'League Gothic',
          fontWeight: 700,
          letterSpacing: '0.14em'
        }} data-id="element-54">
                  {item}
                </a>)}
          </nav>

          {/* Mobile Menu Footer */}
          <div className="flex items-center justify-center pb-8" data-id="element-55">
            <img src="https://cdn.magicpatterns.com/uploads/afZs6hY7Xvo5fyLHudaDXF/adweek.svg" alt="Adweek" className="w-[140px] h-auto object-contain" data-id="element-56" />
          </div>
        </div>}

      <SearchOverlay isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} data-id="element-57" />
    </>;
}